/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */
/* eslint-disable max-len */

export default {
    NEWSLETTERS_title: "Automatic newsletter",
    NEWSLETTERS_blogsTitle: "Customer blogs",
    NEWSLETTERS_tabNewsletters: "Newsletters",
    NEWSLETTERS_tabBlogs: "Blogs",
    NEWSLETTERS_blogsHelp: "The account's RSS feeds and their articles, set up as in the customer's software (RSS blogs).",
    NEWSLETTERS_blogsEmpty: "This customer has no blog yet.",
    NEWSLETTERS_blogsBack: "All blogs",
    NEWSLETTERS_blogDelete: "Delete",
    NEWSLETTERS_blogDeleteStep1: "Warning: deleting the blog “{name}” also deletes its {count} articles, with their newsletter settings. Nothing can be restored.",
    NEWSLETTERS_blogDeleteStep1All: "Warning: deleting the blog “{name}” also deletes all its articles, with their newsletter settings. Nothing can be restored.",
    NEWSLETTERS_blogDeleteContinue: "Continue",
    NEWSLETTERS_blogDeleteStep2: "Last confirmation: the blog “{name}” and its articles will be permanently deleted.",
    NEWSLETTERS_blogDeleteFinal: "Delete permanently",
    NEWSLETTERS_blogDeleted: "Blog deleted, with its articles.",
    NEWSLETTERS_editEmail: "Edit the email",
    NEWSLETTERS_emailPending: "Editing the email from the Console comes with the next API version.",
    NEWSLETTERS_emailTitle: "Newsletter email",
    NEWSLETTERS_emailHeading: "Email — {name}",
    NEWSLETTERS_emailBack: "Statistics",
    NEWSLETTERS_emailSave: "Save",
    NEWSLETTERS_emailQuit: "Quit",
    NEWSLETTERS_emailSaved: "Email saved.",
    NEWSLETTERS_emailSavedNoBlock: "Email saved. It has no block filled at send time (articles, listings, sold listings): the newsletter cannot be activated.",
    NEWSLETTERS_emailQuitUnsaved: "The email has unsaved changes.",
    NEWSLETTERS_emailQuitWithoutSaving: "Leave without saving",
    NEWSLETTERS_emailUndo: "Undo",
    NEWSLETTERS_emailRedo: "Redo",
    NEWSLETTERS_emailImages: "Choose an image",
    NEWSLETTERS_emailImagesPending: "The client's media library could not be read.",
    NEWSLETTERS_mediaTitle:
        "Media manager",
    NEWSLETTERS_mediaClose:
        "Close",
    NEWSLETTERS_mediaAll:
        "All images",
    NEWSLETTERS_mediaSearch:
        "Search by media name",
    NEWSLETTERS_mediaDropHint:
        "Drop your images here or click <u>add</u>. JPG, PNG, GIF, WebP, 20 MB max.",
    NEWSLETTERS_mediaUploading:
        "Uploading…",
    NEWSLETTERS_mediaInvalidFormat:
        "Unsupported format. Accepted formats: JPG, PNG, GIF, WebP.",
    NEWSLETTERS_mediaTooLarge:
        "File too large. Maximum size: 20 MB.",
    NEWSLETTERS_mediaUploadFailed:
        "The image could not be added.",
    NEWSLETTERS_mediaRenameFailed:
        "The image could not be renamed.",
    NEWSLETTERS_mediaNoResults:
        "We found no result matching your search.",
    NEWSLETTERS_mediaEmpty:
        "No image",
    NEWSLETTERS_mediaSelect:
        "Select the image",
    NEWSLETTERS_mediaRename:
        "Click to rename",
    NEWSLETTERS_emailImageUrl: "Image address",
    NEWSLETTERS_emailImageUse: "Use this image",
    NEWSLETTERS_blogAdd: "Add a blog",
    NEWSLETTERS_blogNew: "New blog",
    NEWSLETTERS_blogCreate: "Create the blog",
    NEWSLETTERS_blogCancel: "Cancel",
    NEWSLETTERS_blogCreated: "Blog created: the feed's articles are being imported.",
    NEWSLETTERS_blogCreateHelp: "The blog is created on behalf of the account owner, as if they had added it in RSS blogs.",
    NEWSLETTERS_blogImporting: "Importing articles…",
    NEWSLETTERS_blogFieldsMissing: "Fill in the name, the feed address and the import date.",
    NEWSLETTERS_blogInfo: "General information",
    NEWSLETTERS_blogName: "Blog name",
    NEWSLETTERS_blogFeed: "Blog RSS feed",
    NEWSLETTERS_blogStatus: "Status",
    NEWSLETTERS_blogTracking: "Blog tracking",
    NEWSLETTERS_blogTrackingHelp: "Add once to the blog, in its footer: it works for every article.",
    NEWSLETTERS_blogCtaScript: "Call-to-action script",
    NEWSLETTERS_blogCtaScriptHelp: "Its address is shown in the customer's account (RSS blogs → blog settings); the Console will show it once the API returns it.",
    NEWSLETTERS_blogVisitsScript: "Visit tracking script",
    NEWSLETTERS_blogVisitsHelp: "Will count each article's visits and unique readers. Coming soon.",
    NEWSLETTERS_blogSoon: "Soon",
    NEWSLETTERS_blogPreview: "Blog preview",
    NEWSLETTERS_blogOpen: "Open the blog",
    NEWSLETTERS_blogExtract: "RSS feed extract",
    NEWSLETTERS_blogStartDate: "Import articles from",
    NEWSLETTERS_blogUpdate: "Update",
    NEWSLETTERS_blogValidateUrl: "Validate URL",
    NEWSLETTERS_blogUpdated: "Blog updated: the feed is being read again.",
    NEWSLETTERS_blogArchive: "Archive",
    NEWSLETTERS_blogPublish: "Publish",
    NEWSLETTERS_blogArchived: "Blog archived.",
    NEWSLETTERS_blogPublished: "Blog published.",
    NEWSLETTERS_blogWritePending: "Editing blogs from the Console comes with the next API version.",
    NEWSLETTERS_blogCopy: "Copy",
    NEWSLETTERS_blogCopied: "Copied",
    NEWSLETTERS_blogCtaScriptUse: "Paste once in the blog footer (WordPress: “Custom HTML” block or a code insertion plugin).",
    NEWSLETTERS_blogColAuthor: "Author",
    NEWSLETTERS_blogColExtract: "Article extract",
    NEWSLETTERS_blogColTitle: "Title",
    NEWSLETTERS_blogColUrl: "URL",
    NEWSLETTERS_blogColPublished: "Published on",
    NEWSLETTERS_blogColNewsletter: "Newsletter",
    NEWSLETTERS_blogActive: "Active",
    NEWSLETTERS_blogInactive: "Inactive",
    NEWSLETTERS_blogImportedAt: "Last feed read",
    NEWSLETTERS_blogNoPost: "No article.",
    NEWSLETTERS_blogPostDraft: "Draft",
    NEWSLETTERS_blogPostExcluded: "Excluded from the newsletter",
    NEWSLETTERS_blogPostTargeted: "Targeted",
    NEWSLETTERS_help: "Enable the offer for a customer and set up their newsletters without going through their account. The email is built in the customer's email page builder.",
    NEWSLETTERS_customer: "Customer",
    NEWSLETTERS_customerPlaceholder: "Company, name or email",
    NEWSLETTERS_noCustomer: "No customer found.",
    NEWSLETTERS_back: "Choose another customer",
    NEWSLETTERS_group: "Group {id}",
    NEWSLETTERS_loading: "Loading…",
    NEWSLETTERS_offer: "“Automatic newsletter” offer",
    NEWSLETTERS_offerOnHelp: "Enabled: the customer sees the full screen in the software, and active newsletters go out on time.",
    NEWSLETTERS_offerOffHelp: "Disabled: the customer sees the offer presentation, nothing is sent. Settings are kept.",
    NEWSLETTERS_offerOn: "The offer is enabled for this customer.",
    NEWSLETTERS_offerOff: "The offer is disabled. Sending stops, settings are kept.",
    NEWSLETTERS_offerOffWarning: "The offer is disabled: this newsletter will not go out until it is enabled again.",
    NEWSLETTERS_list: "Customer newsletters",
    NEWSLETTERS_create: "Create a newsletter",
    NEWSLETTERS_empty: "No newsletter for this customer.",
    NEWSLETTERS_frequency: "Frequency",
    NEWSLETTERS_nextSend: "Next send",
    NEWSLETTERS_paused: "Paused",
    NEWSLETTERS_sender: "Sender",
    NEWSLETTERS_noSender: "None",
    NEWSLETTERS_noDynamicBlock: "The email has no block filled at send time (articles, listings or sold listings): the newsletter cannot be turned on. The customer adds one in their email page builder.",
    NEWSLETTERS_noSenderWarning: "Without a sender address, the newsletter does not go out.",
    NEWSLETTERS_updated: "Updated on {date} by {who}",
    NEWSLETTERS_byConsole: "the Facilogi team",
    NEWSLETTERS_byCustomer: "the customer",
    NEWSLETTERS_settings: "Settings",
    NEWSLETTERS_testAndPreview: "Test and preview",
    NEWSLETTERS_statistics: "Statistics",
    NEWSLETTERS_delete: "Delete",
    NEWSLETTERS_deleteConfirm: "Delete the newsletter “{name}” and its email? This cannot be undone.",
    NEWSLETTERS_deleted: "The newsletter was deleted.",
    NEWSLETTERS_saved: "The newsletter was saved.",
    NEWSLETTERS_createTitle: "Create a newsletter",
    NEWSLETTERS_editTitle: "Newsletter settings",
    NEWSLETTERS_save: "Save",
    NEWSLETTERS_emailNote: "The newsletter email (articles, listings, layout) is built in the customer's email page builder. Everything else is here.",
    NEWSLETTERS_sectionGeneral: "General",
    NEWSLETTERS_sectionFrequency: "Frequency",
    NEWSLETTERS_sectionRecipients: "Recipients",
    NEWSLETTERS_fieldName: "Label",
    NEWSLETTERS_nameRequired: "The label is required.",
    NEWSLETTERS_fieldSubject: "Subject",
    NEWSLETTERS_fieldSubjectHelp: "The subject can include contact details: pick them in “Variables”.",
    NEWSLETTERS_fieldSenderName: "Sender name",
    NEWSLETTERS_fieldSenderEmail: "Sender address",
    NEWSLETTERS_senderRequired: "Required for the newsletter to go out.",
    NEWSLETTERS_domainNotValid: "This domain is not authenticated for this customer: the default sender will be used instead of this address.",
    NEWSLETTERS_fieldReplyTo: "Reply-to address",
    NEWSLETTERS_sameReply: "Use the same email for replies",
    NEWSLETTERS_kindWeekly: "Every week, on",
    NEWSLETTERS_kindMonthly: "First of the month",
    NEWSLETTERS_everyWeeks: "every (weeks)",
    NEWSLETTERS_everyMonths: "every (months)",
    NEWSLETTERS_at: "at",
    NEWSLETTERS_fieldNextSend: "Next send",
    NEWSLETTERS_fieldNextSendHelp: "Date set by the frequency. If you change it, only this next send moves: the following ones keep the frequency.",
    NEWSLETTERS_frequencyWeekly: "On {day}, every week, at {time}",
    NEWSLETTERS_frequencyWeeklyN: "On {day}, every {every} weeks, at {time}",
    NEWSLETTERS_frequencyMonthly: "First {day} of the month, at {time}",
    NEWSLETTERS_frequencyMonthlyN: "First {day}, every {every} months, at {time}",
    NEWSLETTERS_weekday1: "Monday",
    NEWSLETTERS_weekday2: "Tuesday",
    NEWSLETTERS_weekday3: "Wednesday",
    NEWSLETTERS_weekday4: "Thursday",
    NEWSLETTERS_weekday5: "Friday",
    NEWSLETTERS_weekday6: "Saturday",
    NEWSLETTERS_weekday7: "Sunday",
    NEWSLETTERS_allContacts: "All contacts",
    NEWSLETTERS_roles: "Link with a property",
    NEWSLETTERS_role1: "Owners",
    NEWSLETTERS_role2: "Tenants",
    NEWSLETTERS_role3: "Former owners",
    NEWSLETTERS_role4: "Former tenants",
    NEWSLETTERS_searches: "Active search",
    NEWSLETTERS_active_buyers: "Active buyers",
    NEWSLETTERS_active_renters: "Active renters",
    NEWSLETTERS_owners_also_buyers: "Owners who also have an active search",
    NEWSLETTERS_tagsIn: "Contacts with tags",
    NEWSLETTERS_addTag: "Add a tag…",
    NEWSLETTERS_contacts: "Chosen contacts",
    NEWSLETTERS_exclude: "Do not send to",
    NEWSLETTERS_excludeTag: "Exclude a tag…",
    NEWSLETTERS_addContact: "Add a contact",
    NEWSLETTERS_excludeContact: "Exclude a contact",
    NEWSLETTERS_contactPlaceholder: "Name or email",
    NEWSLETTERS_contactId: "Contact no. {id}",
    NEWSLETTERS_nobody: "No criteria: nobody will receive the newsletter.",
    NEWSLETTERS_countTotal: "{total} contacts will receive the newsletter",
    NEWSLETTERS_countExcluded: "{excluded} excluded (no address: {noEmail}, not authorized: {notAuthorized}, bounced: {bounced})",
    NEWSLETTERS_testTitle: "Test and preview — {name}",
    NEWSLETTERS_sendTest: "Send test",
    NEWSLETTERS_referenceContact: "View as contact",
    NEWSLETTERS_removeContact: "Remove",
    NEWSLETTERS_noContactHelp: "Without a chosen contact, the test only contains articles open to everyone.",
    NEWSLETTERS_nextSendContent: "In the next send",
    NEWSLETTERS_previewSubject: "Subject",
    NEWSLETTERS_previewSince: "Content published since: {date}",
    NEWSLETTERS_firstSend: "first send, latest ones",
    NEWSLETTERS_previewRecipients: "{recipients} recipients, {withContent} with at least one item",
    NEWSLETTERS_nothingToSend:
        "Nothing new to send: no new article or listing since the last send. The next send will not go out, nor will the test.",
    NEWSLETTERS_nothingToSendNoEmail:
        "The newsletter email has not been created yet. Create it with “Edit the email”, with at least one Articles or Listings block: without it, nothing goes out, neither the test nor the next send.",
    NEWSLETTERS_nothingToSendNoBlog:
        "The email's Articles block is not linked to any blog. Open “Edit the email” and choose the blog in the block: without it, nothing goes out, neither the test nor the next send.",
    NEWSLETTERS_articlesBlock: "Articles block {index} ({total} max)",
    NEWSLETTERS_noArticle: "No article.",
    NEWSLETTERS_previewListings: "{count} listings in the listing blocks",
    NEWSLETTERS_listingsBlock: "Listing block {index}: {count} listing(s)",
    NEWSLETTERS_contactReceives: "This contact would receive {count} articles.",
    NEWSLETTERS_forThisContact: "For this contact",
    NEWSLETTERS_articlesTitle: "Articles: x{count}",
    NEWSLETTERS_articlesTitleIndexed: "Articles {index}: x{count}",
    NEWSLETTERS_listingsKind_sale: "Listings for sale: x{count}",
    NEWSLETTERS_listingsKind_rental: "Listings for rent: x{count}",
    NEWSLETTERS_listingsKind_all: "Listings: x{count}",
    NEWSLETTERS_listingsKind_sold: "Sold listings: x{count}",
    NEWSLETTERS_ruleFilter_LastPublished: "Latest published articles",
    NEWSLETTERS_ruleFilter_MostPopular: "Most viewed articles",
    NEWSLETTERS_ruleFilter_TagBased: "Articles by tags",
    NEWSLETTERS_ruleTags: "Article tags: {names}",
    NEWSLETTERS_ruleNoTags: "Article tags: none",
    NEWSLETTERS_ruleTotal: "Number of articles: {count}",
    NEWSLETTERS_ruleListingsKind: "Listings to show: {kind}",
    NEWSLETTERS_ruleListingsTotal: "Number of listings: {count}",
    NEWSLETTERS_ruleKind_sale: "Latest sales",
    NEWSLETTERS_ruleKind_rental: "Latest rentals",
    NEWSLETTERS_ruleKind_all: "Latest sales and rentals",
    NEWSLETTERS_noContactFound: "No contact found for “{keyword}”.",
    NEWSLETTERS_testEmail: "Test email",
    NEWSLETTERS_testSent: "The test was sent to {email}.",
    NEWSLETTERS_backToList: "Back to the customer's list",
    NEWSLETTERS_eligible: "Eligible contacts",
    NEWSLETTERS_eligibleOf: "out of {matched} contacts matching the criteria",
    NEWSLETTERS_excludedHead: "Excluded",
    NEWSLETTERS_excludedNoEmail: "No email address",
    NEWSLETTERS_excludedNotAuthorized: "Consent refused (GDPR)",
    NEWSLETTERS_excludedBounced: "Failed addresses",
    NEWSLETTERS_noDeliveryYet: "No email delivered yet.",
    NEWSLETTERS_openedEmails: "Opened e-mails",
    NEWSLETTERS_openedOf: "out of {delivered} delivered e-mails",
    NEWSLETTERS_demoBanner:
        "Demo data: articles and contacts come from the customer, the figures are made up for design work. Remove ?demo=1 from the address to see the real figures.",
    NEWSLETTERS_chartTitle: "Opens and clicks, send after send",
    NEWSLETTERS_miniRecipients: "recipients, per send",
    NEWSLETTERS_miniDelivered: "delivered, per send",
    NEWSLETTERS_miniOpened: "opens, per send",
    NEWSLETTERS_miniClicked: "clicks, per send",
    NEWSLETTERS_miniUnsubscribed: "unsubscribes, per send",
    NEWSLETTERS_recipientsToday: "{count} recipients today",
    NEWSLETTERS_statsTitle: "Statistics — {name}",
    NEWSLETTERS_from: "From",
    NEWSLETTERS_to: "to",
    NEWSLETTERS_apply: "Apply",
    NEWSLETTERS_sendsDone: "Sends done",
    NEWSLETTERS_sendsSkipped: "{count} skipped, no content",
    NEWSLETTERS_emailsSent: "Emails sent",
    NEWSLETTERS_deliveredBounced: "{delivered} delivered, {bounced} bounced",
    NEWSLETTERS_opens: "Opens",
    NEWSLETTERS_uniqueUnder: "{count} unique, under-counted",
    NEWSLETTERS_clicks: "Clicks",
    NEWSLETTERS_uniqueCto: "{count} unique, {cto} of opens",
    NEWSLETTERS_unsubscribed: "Unsubscribes",
    NEWSLETTERS_spam: "{count} complaints",
    NEWSLETTERS_lastTargeted: "Last send: {targeted} targeted, {recipients} recipients",
    NEWSLETTERS_opensWarning: "Opens rely on the tracking pixel: they are under-counted. Clicks are the reliable figure; clicked articles arrive the next day.",
    NEWSLETTERS_openRate: "Open rate",
    NEWSLETTERS_clickRate: "Click rate",
    NEWSLETTERS_sends: "Send history",
    NEWSLETTERS_noSend: "No send yet.",
    NEWSLETTERS_colDate: "Date",
    NEWSLETTERS_colStatus: "Status",
    NEWSLETTERS_colArticles: "Articles",
    NEWSLETTERS_colRecipients: "Recipients",
    NEWSLETTERS_colDelivered: "Delivered",
    NEWSLETTERS_colOpened: "Opens",
    NEWSLETTERS_colClicked: "Clicks",
    NEWSLETTERS_colUnsubscribed: "Unsubscribed",
    NEWSLETTERS_sendPosts: "Articles in this send",
    NEWSLETTERS_postLine: "{title} — received by {recipients}, {clicks} clicks",
    NEWSLETTERS_sendContacts: "Contacts: articles received, open, articles clicked",
    NEWSLETTERS_opened: "Opened",
    NEWSLETTERS_ranking: "Article ranking",
    NEWSLETTERS_colArticle: "Article",
    NEWSLETTERS_colTimesSent: "Sends",
    NEWSLETTERS_colReached: "Contacts reached",
    NEWSLETTERS_colClicks: "Clicks",
    NEWSLETTERS_status_scheduled: "Sent",
    NEWSLETTERS_status_skipped_no_article: "Skipped: no content",
    NEWSLETTERS_status_skipped_no_recipient: "Skipped: no recipient",
    NEWSLETTERS_status_skipped_no_sender: "Skipped: no sender",
    NEWSLETTERS_status_failed: "Failed",
    NEWSLETTERS_error_no_dynamic_block: "The email has no block filled at send time (articles, listings or sold listings): the newsletter cannot be turned on.",
    NEWSLETTERS_error_newsletter_not_found: "Newsletter not found for this customer.",
    NEWSLETTERS_error_contact_not_found: "This contact does not belong to this customer.",
    NEWSLETTERS_error_newsletter_without_sender: "Set the sender address before testing.",
    NEWSLETTERS_error_no_article: "This contact would receive no content at the next send: the test is not sent.",
    NEWSLETTERS_error_invalid_newsletter: "A field is not valid.",
    NEWSLETTERS_error_invalid_search: "The recipient selection is not valid.",
    NEWSLETTERS_error_route_not_allowed: "Call refused by the Console.",
    NEWSLETTERS_error_image_required: "No file received: choose an image.",
    NEWSLETTERS_error_image_invalid: "This file is not an image.",
    NEWSLETTERS_error_name_required: "Give the image a name.",
    NEWSLETTERS_error_name_too_long: "The image name is longer than 200 characters.",
    NEWSLETTERS_error_public_media_not_found: "This image does not belong to this client.",
    NEWSLETTERS_error_group_without_user:
        "This client has no user: the image cannot be stored under their name.",

    NEWSLETTERS_enableForCustomer: "Enable for a customer",
    NEWSLETTERS_filter_enabled: "Enabled",
    NEWSLETTERS_filter_disabled: "Disabled",
    NEWSLETTERS_filter_all: "All",
    NEWSLETTERS_noOffer: "No customer in this list.",
    NEWSLETTERS_colCustomer: "Customer",
    NEWSLETTERS_colOffer: "Offer",
    NEWSLETTERS_colNewsletters: "Newsletters",
    NEWSLETTERS_colActive: "Active",
    NEWSLETTERS_colNewsletter: "Newsletter",
    NEWSLETTERS_colOn: "Status",
    NEWSLETTERS_colEnabledBy: "Changed on / by",
    NEWSLETTERS_stateOn: "Enabled",
    NEWSLETTERS_stateOff: "Disabled",
    NEWSLETTERS_offersPending: "The list of customers with the offer is waiting for an API route (requested on 21/10). Meanwhile, search for the customer.",
    NEWSLETTERS_relayMissing: "The Console server does not have the automatic newsletter yet: the Console backend (branch hotfix28) must be deployed to staging. Until then, neither the list nor activation can work; customer search can.",
    NEWSLETTERS_cadenceMonthly: "Every month",
    NEWSLETTERS_cadenceMonthlyN: "Every {every} months",
    NEWSLETTERS_cadenceWeekly: "Every week",
    NEWSLETTERS_cadenceWeeklyN: "Every {every} weeks",
    NEWSLETTERS_contactSearchHint: "Type at least two letters of the name or email.",
    NEWSLETTERS_copyVariable: "Copy",
    NEWSLETTERS_emailInvalid: "Invalid email address.",
    NEWSLETTERS_excludeContacts: "Do not send to these contacts",
    NEWSLETTERS_excludeTags: "Do not send to contacts with tags",
    NEWSLETTERS_explainAllCovers: "(“All contacts” already includes the other checked criteria)",
    NEWSLETTERS_explainBounced: "{count} bounced addresses",
    NEWSLETTERS_explainContacts: "{count} contacts picked one by one",
    NEWSLETTERS_explainExcluded: "excluded: {details}",
    NEWSLETTERS_explainNoEmail: "{count} without email",
    NEWSLETTERS_explainNotAuthorized: "{count} consent refused (GDPR)",
    NEWSLETTERS_explainOr: " or ",
    NEWSLETTERS_explainRemoved: "removed by “Do not send”: {criteria}",
    NEWSLETTERS_explainRetained: "contacts: {criteria}",
    NEWSLETTERS_explainRule: "A contact removed by “Do not send” never receives the newsletter, even if they match another checked criterion.",
    NEWSLETTERS_explainTags: "contacts with {tags}",
    NEWSLETTERS_explainTitle: "How this number is reached:",
    NEWSLETTERS_fieldCadence: "Frequency",
    NEWSLETTERS_fieldFirstWeekday: "First",
    NEWSLETTERS_fieldRequired: "Required for the newsletter to go out.",
    NEWSLETTERS_fieldTime: "At",
    NEWSLETTERS_fieldWeekday: "On",
    NEWSLETTERS_noResult: "No result.",
    NEWSLETTERS_recipientsRequired: "Check at least one recipient criterion.",
    NEWSLETTERS_saveAndCreate: "Save and create the newsletter",
    NEWSLETTERS_searchTag: "Search a tag",
    NEWSLETTERS_searchVariable: "Search a variable",
    NEWSLETTERS_variables: "Variables",
    NEWSLETTERS_variablesLegal: "Contact (company)",
    NEWSLETTERS_variablesNatural: "Contact (person)",
    NEWSLETTERS_variablesOwner: "Contact's agent",
    NEWSLETTERS_variablesDate: "Send date",
    NEWSLETTERS_dateDay: "Day",
    NEWSLETTERS_dateMonth: "Month",
    NEWSLETTERS_dateMonthYear: "Month and year",
    NEWSLETTERS_dateYear: "Year",
    NEWSLETTERS_groupTags: "Tags",
    NEWSLETTERS_groupContacts: "Contacts",
    NEWSLETTERS_sendTo: "Send to",
    NEWSLETTERS_sendToHelp: "A contact receives the newsletter if they match at least one of these criteria.",
    NEWSLETTERS_doNotSendTo: "Do not send to",
    NEWSLETTERS_doNotSendToHelp: "Removed even if they match a “Send to” criterion.",
    NEWSLETTERS_tagsWith: "Contacts with these tags",
    NEWSLETTERS_contactsOneByOne: "Contacts picked one by one",
    NEWSLETTERS_bubbleTitle: "Which article drives the most activity",
    NEWSLETTERS_bubbleNote: "One bubble per article sent in the period: across, the contacts who opened an e-mail containing it; up, the share of those readers who clicked to read it. Click a bubble to open the article.",
    NEWSLETTERS_bubbleX: "Opens",
    NEWSLETTERS_bubbleY: "Click-to-open rate",
    NEWSLETTERS_bubbleSize: "size = blog visits",
    NEWSLETTERS_stageLabel: "Stage",
    NEWSLETTERS_stageAll: "All",
    NEWSLETTERS_stageTop: "Top of funnel",
    NEWSLETTERS_stageMiddle: "Middle of funnel",
    NEWSLETTERS_stageBottom: "Bottom of funnel",
    NEWSLETTERS_stageNone: "No stage",
    NEWSLETTERS_stageHint: "The stage is read from the TOFU, MOFU or BOFU tag on the article.",
    NEWSLETTERS_stageMissing: "No article has a TOFU, MOFU or BOFU tag yet: every bubble is \"No stage\".",
    NEWSLETTERS_colStage: "Stage",
    NEWSLETTERS_bubbleClicks: "{count} clicks ({rate} of readers)",
    NEWSLETTERS_bubbleVisits: "{count} blog visits",
    NEWSLETTERS_bubbleOpen: "Click to open the article",
    NEWSLETTERS_bubbleOpened: "{count} opens",
    NEWSLETTERS_bubblePosition: "Average place in the e-mail: {position}",
    NEWSLETTERS_bubbleFew: "Fewer than {count} opens: too few to conclude",
    NEWSLETTERS_bubbleCaveat: "Opens are approximate (blocked images, automatic opens by Apple Mail): use the rate to compare articles with each other. A pale bubble has fewer than 20 opens.",
    NEWSLETTERS_bubbleWaiting: "No opens per article yet for this period. The bubbles appear with the first opens.",
    NEWSLETTERS_demoHypothesis:
        "Assumption: 3,000 eligible contacts, one newsletter every two weeks for six months (13 sends, one skipped for lack of articles), 6 articles per send, i.e. 12 a month (72 articles), 20% average open rate. Articles: 50% TOFU, 30% MOFU, 20% BOFU.",
    NEWSLETTERS_sinceFirstSend: "Since the first send",
    NEWSLETTERS_periodRange: "{from} to {to}",
    NEWSLETTERS_periodThisWeek: "This week",
    NEWSLETTERS_periodLastWeek: "Last week",
    NEWSLETTERS_periodThisMonth: "This month",
    NEWSLETTERS_periodLastMonth: "Last month",
    NEWSLETTERS_periodLast3Months: "Last 3 months",
    NEWSLETTERS_periodLast6Months: "Last 6 months",
    NEWSLETTERS_periodThisYear: "This year",
    NEWSLETTERS_periodLastYear: "Last year",
    NEWSLETTERS_overviewTitle: "Performance",
    NEWSLETTERS_overviewSubtitle: "What the newsletter produced over the period.",
    NEWSLETTERS_quick3m: "3 months",
    NEWSLETTERS_quick6m: "6 months",
    NEWSLETTERS_quick1y: "1 year",
    NEWSLETTERS_quickAll: "All",
    NEWSLETTERS_quickCustom: "Custom",
    NEWSLETTERS_funnelTitle: "From recipient to reader",
    NEWSLETTERS_funnelSubtitle: "E-mails sent → delivered → opened → clicked → blog visits",
    NEWSLETTERS_funnelSent: "Sent",
    NEWSLETTERS_funnelDelivered: "Delivered",
    NEWSLETTERS_funnelOpened: "Opened",
    NEWSLETTERS_funnelClicked: "Clicked",
    NEWSLETTERS_funnelVisits: "Blog visits",
    NEWSLETTERS_funnelStart: "starting point",
    NEWSLETTERS_funnelOfSent: "of sent",
    NEWSLETTERS_funnelOfDelivered: "of delivered",
    NEWSLETTERS_funnelOfOpened: "of opened",
    NEWSLETTERS_funnelOfClicked: "of clicked",
    NEWSLETTERS_funnelSoon: "Coming soon",
    NEWSLETTERS_funnelNote: "Heights are softened so small steps stay readable; numbers are exact. Opens are under-counted (tracking pixel).",
    NEWSLETTERS_funnelUnitEmails: "e-mails",
    NEWSLETTERS_funnelUnitContacts: "contacts",
    NEWSLETTERS_funnelUnitVisits: "visits",
    NEWSLETTERS_sendsSkippedOne: "{count} send skipped for lack of content",
    NEWSLETTERS_spamOne: "{count} complaint",
    NEWSLETTERS_sendsSubtitle: "Click a row: its contacts and its articles.",
    NEWSLETTERS_rankingSubtitle: "Most clicked first. Click a title to open the article.",
    NEWSLETTERS_colOpenedPost: "Opens",
    NEWSLETTERS_colCtor: "Click-to-open rate"
};
